/**
 * FR8BOT API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CustomerPermission = {
    UsersRead: 'USERS_READ',
    UsersFull: 'USERS_FULL',
    LoadRead: 'LOAD_READ',
    LoadFull: 'LOAD_FULL',
    CompanyInfoRead: 'COMPANY_INFO_READ',
    CompanyInfoFull: 'COMPANY_INFO_FULL',
    MapRead: 'MAP_READ'
} as const;
export type CustomerPermission = typeof CustomerPermission[keyof typeof CustomerPermission];

